import { styled } from 'styled-components';

export const DeviceImage = styled.img<{ $hover: boolean }>`
  width: 100%;
  aspect-ratio: 1;
  object-fit: contain;

  transform: rotate(
    ${(props) => {
      return props.$hover ? '-90deg' : '0deg';
    }}
  );
`;
